import axiosServer from '../../configs/axiosServer'
import axiosServerGolang from '../../configs/axiosServerGolang'
import { USER_AUTH_ENDPOINT } from '../../constants/endpoints'
import CrazyEgg from '@/configs/crazyEgg'
import { showErrorAlert } from '@/functions/showErrorAlert'
import userAPI from '@/api/user'

const user = {
  namespaced: true,
  state: {
    userHasPIN: true,
    userPreference: {},
    showCropper: false,
    showChangePasswordModal: false,
    userInfo: {},
    isLogin: false,
    userValidation: {},
    myProfile: {},
    currentUser: {},
    isCikal: false,
    resendEmailCounter: 0,
    relations: [],
    // otp verification
    canSendOTP: true,
    isOpenVerificationInvitation: false,
    isOpenVerificationOtp: false,
    isHideSkipVerification: false,
    isVerificationMandatory: false,
    isTemporarilyFreezeOtpVerification: false,
    isShowUnfreezeVerificationSnackbar: false,
    unfreezeVerificationSnackbarTextType: 'active'
  },
  mutations: {
    SET_USER (state, payload) {
      state.userInfo = payload
      CrazyEgg.setCrazyEggUserVariable({
        userId: state.userInfo.id || null,
        professionName: state.userInfo.profession_name || '',
        yearLevelName: state.userInfo.year_level_name || '',
        roleLabel: state.userInfo.role[0] ? state.userInfo.role[0].label : '',
        prakerjaStatus: state.userInfo.prakerja_id ? 'Prakerja User' : 'Non-Prakerja User'
      })
    },
    SET_USER_HAS_PIN (state, payload) {
      state.userHasPIN = payload
    },
    SET_USER_PREFERENCE (state, payload) {
      state.userPreference = payload
    },
    SET_RELATION (state, payload) {
      state.relations = payload
    },
    SET_AVATAR (state, avatar) {
      state.userInfo = { ...state.userInfo, avatar }
    },
    SET_PRAKERJA_ID (state, prakerja_id) {
      state.userInfo = { ...state.userInfo, prakerja_id }
    },
    SET_SHOW_MODAL (state) {
      state.showChangePasswordModal = !state.showChangePasswordModal
    },
    SET_SHOW_CROPPER (state) {
      state.showCropper = !state.showCropper
    },
    CHANGE_IS_LOGIN (state, payload) {
      state.isLogin = payload
    },
    CHANGE_CURRENT_USER (state, payload) {
      state.userValidation = payload
    },
    CHANGE_MY_PROFILE (state, payload) {
      state.myProfile = payload
    },
    CHANGE_USER (state, payload) {
      state.currentUser = payload
    },
    SET_IS_CIKAL (state, payload) {
      // state.isCikal = payload
      state.isCikal = false
    },
    SET_RESEND_COUNTER (state, payload) {
      state.resendEmailCounter = payload
    },
    CHANGE_CAN_SEND_OTP (state, payload) {
      state.canSendOTP = payload
    },
    CHANGE_IS_OPEN_VERIFICATION_INVITATION (state, payload) {
      state.isOpenVerificationInvitation = payload
    },
    CHANGE_IS_OPEN_VERIFICATION_OTP (state, payload) {
      state.isOpenVerificationOtp = payload
    },
    CHANGE_IS_HIDE_SKIP_VERIFICATION (state, payload) {
      state.isHideSkipVerification = payload
    },
    CHANGE_IS_VERIFICATION_MANDATORY (state, payload) {
      state.isVerificationMandatory = payload
    },
    CHANGE_IS_TEMPORARILY_FREEZE_OTP_VERIFICATION (state, payload) {
      state.isTemporarilyFreezeOtpVerification = payload
    },
    CHANGE_IS_SHOW_UNFREEZE_SNACKBAR (state, payload) {
      state.isShowUnfreezeVerificationSnackbar = payload
    },
    CHANGE_UNFREEZE_VERIFICATION_SNACKBAR_TEXT_TYPE (state, payload) {
      state.unfreezeVerificationSnackbarTextType = payload
    }
  },
  actions: {
    async getUserPreferenceContent ({ commit, rootState }) {
      try {
        const { data } = await userAPI.getPreferenceContent(rootState.storage.accessToken)
        if (data.status === 200) {
          commit('SET_USER_PREFERENCE', data.data)
        } else {
          throw data
        }
      } catch (error) {
        commit('SET_USER_PREFERENCE', [])
      }
    },
    async getPrakerjaProfile ({ commit, rootState }) {
      try {
        const { data } = await axiosServerGolang({
          url: USER_AUTH_ENDPOINT,
          method: 'POST',
          headers: {
            Authorization: rootState.storage.accessToken
          }
        })
        if (data.status === 200 || data.message === 'OK') {
          commit('CHANGE_CURRENT_USER', data.data)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getUserProfile ({ commit, rootState }, payload) {
      try {
        const { data } = await axiosServer({
          url: `/user/view/get_bulk/${payload}`,
          method: 'GET',
          headers: {
            Authorization: rootState.storage.accessToken
          }
        })
        if (data.status === 200 || data.message === 'OK') {
          commit('CHANGE_CURRENT_USER', data.data[0])
        }
      } catch (error) {
        console.error(error)
      }
    },
    async fetchUserData ({ commit, rootState }, payload) {
      try {
        const newPayload = payload || {}
        const isRefresh = newPayload.isRefresh ? '?refresh=1' : ''
        const { data } = await axiosServerGolang.post(`${USER_AUTH_ENDPOINT}${isRefresh}`, {}, {
          headers: {
            Authorization: newPayload.token || rootState.storage.accessToken
          }
        })
        if (data.status === 200) {
          commit('SET_USER', data.data)
          if (newPayload.token) {
            commit(
              'storage/SET_ACCESS_TOKEN',
              newPayload.token,
              { root: true }
            )
          }
          switch (rootState.activeEnv) {
            case 'staging':
              commit('SET_IS_CIKAL', !!data.data.user_group.filter(group => group.group_id === 231).length)
              break
            case 'production':
              commit('SET_IS_CIKAL', !!data.data.user_group.filter(group => group.group_id === 162).length)
              break
            default:
              commit('SET_IS_CIKAL', !!data.data.user_group.filter(group => group.group_id === 230).length)
              break
          }
        } else {
          commit('SET_IS_CIKAL', false)
        }
        return data
      } catch (err) {
        console.error(err)
        commit('SET_IS_CIKAL', false)
        showErrorAlert(err, null, null, 'ERRV2AUT')
        return { status: 400 }
      }
    },
    async fetchRelationData ({ commit, rootState }) {
      try {
        const { data } = await axiosServer.get('/user/relation_user/get/request/', {
          headers: {
            Authorization: rootState.storage.accessToken
          }
        })
        if (data.status === 200) {
          commit('SET_RELATION', data.data)
        } else {
          commit('SET_RELATION', [])
        }
      } catch (err) {
        commit('SET_RELATION', [])
      }
    },
    async saveEditedProfile ({ dispatch, rootState }, payload) {
      try {
        const { data } = await userAPI.updateProfile(
          rootState.storage.accessToken,
          payload
        )
        if (data.status === 200) {
          dispatch('fetchUserData')
          return {
            ...data,
            variant: 'success',
            alertMessage: 'Perubahan data profil berhasil disimpan'
          }
        } else {
          throw data
        }
      } catch (error) {
        return {
          ...error,
          variant: 'danger',
          alertMessage: error.message || 'Terjadi kesalahan pada server, data tidak disimpan'
        }
      }
    },
    async forgotPassword ({ commit }, payload) {
      try {
        const { data } = await axiosServer({
          method: 'POST',
          url: '/user/recover_password/',
          headers: {
            Authorization: process.env.VUE_APP_APP_KEY
          },
          data: {
            email: payload
          }
        })
        return data
      } catch (error) {
        console.error(error)
      }
    },
    async saveEditedAvatar ({ rootState }, payload) {
      try {
        await axiosServer.post('/user/manage/', payload, {
          headers: {
            Authorization: rootState.storage.accessToken
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    async getMyProfile ({ commit, rootState }) {
      try {
        const { data } = await axiosServerGolang({
          url: USER_AUTH_ENDPOINT,
          method: 'POST',
          headers: {
            Authorization: rootState.storage.accessToken
          }
        })
        if (data.status === 200 || data.message === 'OK') {
          commit('CHANGE_MY_PROFILE', data.data)
          const currentUser = {}
          currentUser.name = data.data.name
          currentUser.id = data.data.id
          currentUser.year_level = data.data.year_level_name
          currentUser.avatar = data.data.avatar
          commit('CHANGE_USER', currentUser)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async fetchNotification ({ commit, rootState }, payload) {
      // Make sure userInfo is not empty
      if (!rootState.user.userInfo || !rootState.user.userInfo.username) {
        await new Promise(resolve => setTimeout(resolve, 1000))
        if (!rootState.user.userInfo.username) {
          return null
        }
      }
      const collectionPath = `notifications/general_notifications/users/${rootState.user.userInfo.username}/notifications`
      const db = window.firestore.collection(collectionPath)
      if (payload.lastVisible) {
        return db
          .where('object_type', 'in', payload.types)
          .orderBy('sent_at', payload.sort)
          .startAfter(payload.lastVisible)
          .limit(payload.total_item)
      } else {
        return db
          .where('object_type', 'in', payload.types)
          .orderBy('sent_at', payload.sort)
          .limit(payload.total_item)
      }
    }
  }
}

export default user
